import styled from '@common/theme/styled-components';

export const ContactsAddresses = styled.div`
  padding-top: ${(props) => props.theme.largePadding};
`;
